export const letters = [
    "پ",
    "چ",
    "ج",
    "ح",
    "خ",
    "ه",
    "ع",
    "غ",
    "ف",
    "ق",
    "ث",
    "ص",
    "ض",
    "گ",
    "ک",
    "م",
    "ن",
    "ت",
    "ا",
    "ل",
    "ب",
    "ی",
    "س",
    "ش",
    "و",
    // "ئ",
    "ذ",
    "ر",
    "ز",
    "ط",
    "ظ",
    "ژ",
]